import Snotify, {
    SnotifyPosition
} from 'vue-snotify'
import Lang from '@/lang';

export default {
    install(Vue, options) {

        const optionsDefaults = {
            toast: {
                position: this.getSnotifyPosition(),
                showProgressBar: false
            }
        }

        // Merge options argument into options defaults
        options = {
            ...optionsDefaults,
            ...options
        }

        Vue.use(Snotify, options);

        Vue.showLoading = function (msg = 'Loading data...') {
            Vue.prototype.$snotify.info(msg, {
                timeout: 0,
                icon: '/images/oval.svg'
            });
        }

        Vue.hideAllNotify = function(){            
            Vue.prototype.$snotify.clear();
        }

    },

    getSnotifyPosition() {
      const currentLang = Lang.getLocale();
      const isRTL = currentLang === 'ar';
      
      return isRTL ? 'leftBottom' : 'rightBottom';
    },
}
